import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import Cookies from 'js-cookie';
import { Navigate, useNavigate } from 'react-router-dom';
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
    Bom: [],
    category: [],
    subCategory: [],
    products: [],
    success: false,
    message: '',
    loading: false,
};


const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getBom = createAsyncThunk(
    'Bom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allBillOfMaterial', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getBomById = createAsyncThunk(
    'BomById/get',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getBomById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data);
            dispatch(getBom());
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const addBom = createAsyncThunk(
    'Bom/add',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log(data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createBillOfMaterial', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteBom = createAsyncThunk(
    'Bom/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteBillOfMaterial/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editBom = createAsyncThunk(
    'Bom/edit',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log("data", data);
        try {
            const { _id, ...rest } = data;
            // console.log(data);
            const response = await axiosInstance.put(`${BASE_URL}/updateBillOfMaterial/${_id}`, rest, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getBom());
            return response.data.bom;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getcategoryBom = createAsyncThunk(
    'categoryBom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getBomCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getsubcategoryBom = createAsyncThunk(
    'subcategoryBom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getBomSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getproductBom = createAsyncThunk(
    'productBom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getBomProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstoreBom = createAsyncThunk(
    'storeBom/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getBomstore', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const BomSlice = createSlice({
    name: 'Bom',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBom.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.Bom = action.payload;
            })
            .addCase(getBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
            .addCase(addBom.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Bill Of Material...';
            })
            .addCase(addBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Bom?.push(action.payload);
                state.message = action.payload?.message || 'Bill Of Material added successfully';
            })
            .addCase(addBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Bill Of Material';
            })
            .addCase(deleteBom.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Bill Of Material...';
            })
            .addCase(deleteBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Bom = state.Bom.filter((Boms) => Boms._id !== action.payload);
                state.message = action.payload?.message || 'Bill Of Material deleted successfully';
            })
            .addCase(deleteBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Bill Of Material';
            })
            .addCase(editBom.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Bill Of Material...';
            })
            .addCase(editBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Bom = state.Bom.map((Boms) =>
                    Boms._id === action.payload._id ? action.payload : Boms
                );
                state.message = action.payload?.message || 'Bill Of Material updated successfully';
            })
            .addCase(editBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Bill Of Material';
            })
            .addCase(getBomById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getBomById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.Bom = action.payload;
            })
            .addCase(getBomById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
            .addCase(getcategoryBom.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getcategoryBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.category = action.payload;
            })
            .addCase(getcategoryBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
            .addCase(getsubcategoryBom.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getsubcategoryBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.subCategory = action.payload;
            })
            .addCase(getsubcategoryBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
            .addCase(getproductBom.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getproductBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.products = action.payload;
            })
            .addCase(getproductBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
            .addCase(getstoreBom.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Bill Of Material...';
            })
            .addCase(getstoreBom.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Bill Of Material fetched successfully';
                state.store = action.payload;
            })
            .addCase(getstoreBom.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Bill Of Material';
            })
    }
});

export default BomSlice.reducer;